import { z } from 'zod';
export const OwnerOptionsSchema = z.object({
    xaAutoExport: z.boolean().optional(),
});
